import axios from "axios"
import baseURL from "../config/api"

export const post_Event = (data: any, token: string) => {
    return axios({
        url: `${baseURL}event`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Event = (data: any, token: string) => {
    return axios({
        url: `${baseURL}event`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_Event = (primaryKey: string, token: string) => {
    return axios({
        url: `${baseURL}event`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const getEventByGroupId = (groupId: number, token: string) => {
    return getFetch("event", token, { groupId })
}

export const getEvent = (primaryKey: string, token: string) => {
    return getFetch(`event/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}